import { Path } from '../../models'

import { isSamePath } from './isSamePath'

export const isHomePath = isSamePath(Path.Home)
